import { render } from "./RatingButtons.vue?vue&type=template&id=5e440403"
import script from "./RatingButtons.vue?vue&type=script&lang=js"
export * from "./RatingButtons.vue?vue&type=script&lang=js"

import "./RatingButtons.vue?vue&type=style&index=0&id=5e440403&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__